module.exports = __webpack_public_path__ + "static/media/diaadia-2.c7c152c4.jpg";